import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Button,Toast } from 'vant'
import * as API from './api'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import MetaInfo from 'vue-meta-info'
import './plugins.js'
import store from './store'
Vue.config.productionTip = false
Vue.prototype.$API = API

Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component(Button.name, Button)
Vue.use(Toast);
Vue.use(MetaInfo)

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
